import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '../../mui-styles-bridge.js';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { addPageData } from '../../store/form/actions';
import Comment from './Comment';

const styles = (theme) => ({
  checkbox: {
    marginRight: 40,
    color: '#afafaf',
  },
  checked: {},
  listtext: {
    fontSize: '13px',
  },
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
});

class Multiplechoice extends React.Component {
  constructor(props) {
    super(props);

    this.state = { multiple_answer: {} };
  }

  findIndex = (data, container) => {
    function hasObject(element, target) {
      // Check if element matches target exactly (both as strings)
      if (element.toString() == target.toString()) {
        return true;
      }
      // Also check if target matches the value part of an option array
      // Options are formatted as [value, label], so element[0] is the value
      if (Array.isArray(element) && element[0] === target) {
        return true;
      }
      // Handle case where target is an array and we need to match just the value
      if (
        Array.isArray(target) &&
        Array.isArray(element) &&
        element[0] === target[0]
      ) {
        return true;
      }
      return false;
    }

    let i = container.findIndex((n) => {
      let a = hasObject(n, data);
      if (a == true) {
        return true;
      }
    });
    return i;
  };

  componentDidMount() {
    let temp = this.state.multiple_answer;
    this.props.data.data.map((n) => {
      temp[n[0]] = false;
    });
    let answer_data = this.props.form.answer_data[this.props.data.key];
    if (answer_data && answer_data.answer) {
      for (let key in this.props.form.answer_data[this.props.data.key].answer) {
        let index = this.findIndex(
          this.props.form.answer_data[this.props.data.key].answer[key],
          this.props.data.data
        );

        if (index >= 0 && this.props.data.data[index]) {
          temp[this.props.data.data[index][0]] = true;
        }
      }

      this.setState({ multiple_answer: temp });
    } else {
      if (this.props.data.auto.toString()) {
        let temp = this.state.multiple_answer;
        this.props.data.data.map((n) => {
          temp[n[0]] = false;
        });
        let index = this.findIndex(this.props.data.auto, this.props.data.data);

        if (index >= 0 && this.props.data.data[index]) {
          temp[this.props.data.data[index][0]] = true;
          this.props.dispatchaddPageData(
            this.props.data.key,
            typeof this.props.data.auto[0] == 'object'
              ? this.props.data.auto
              : [this.props.data.auto],
            this.props.data.question_text
          );

          this.setState({ multiple_answer: temp });
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //if ((this.props.data.auto.toString()) && !this.props.form.answer_data[this.props.data.key]) {
    if (this.props.data.auto != prevProps.data.auto) {
      let temp = this.state.multiple_answer;
      this.props.data.data.map((n) => {
        temp[n[0]] = false;
      });
      let index = this.findIndex(this.props.data.auto, this.props.data.data);

      if (this.props.data.data[index]) {
        temp[this.props.data.data[index][0]] = true;
        this.props.dispatchaddPageData(
          this.props.data.key,
          typeof this.props.data.auto[0] == 'object'
            ? this.props.data.auto
            : [this.props.data.auto],
          this.props.data.question_text
        );
        // this.props.getDataFromComponent({multiple_answer: temp},this.props.data.key,this.props.data.question_text,this.props.data.data)
        this.setState({ multiple_answer: temp });
      }
    }
  }

  handleChange = (name) => (event) => {
    let temp = this.state.multiple_answer;
    temp[name] = !temp[name];
    this.setState({ multiple_answer: temp });
    this.props.getDataFromComponent(
      this.state,
      this.props.data.key,
      this.props.data.question_text,
      this.props.data.data
    );
  };

  handleAutoValueChange = () => {
    const { data, form, dispatchaddPageData } = this.props;

    const hasExistingAnswer =
      form.answer_data[data.key] &&
      form.answer_data[data.key].answer &&
      form.answer_data[data.key].answer.length > 0;

    if (data.auto && data.auto.toString()) {
      let temp = this.state.multiple_answer;
      data.data.map((n) => {
        temp[n[0]] = false;
      });
      let index = this.findIndex(data.auto, data.data);

      if (index >= 0 && data.data[index]) {
        temp[data.data[index][0]] = true;
        dispatchaddPageData(
          data.key,
          typeof data.auto[0] == 'object' ? data.auto : [data.auto],
          data.question_text
        );
        this.setState({ multiple_answer: temp });
      }
    } else if (!data.auto || !data.auto.toString()) {
      if (hasExistingAnswer) {
        let temp = this.state.multiple_answer;
        data.data.map((n) => {
          temp[n[0]] = false;
        });
        dispatchaddPageData(data.key, [], data.question_text);
        this.setState({ multiple_answer: temp });
      }
    }
  };

  doNothing = () => {};
  render() {
    const { classes, form, data } = this.props;
    try {
      return (
        <div className={classes.root}>
          <List component="nav">
            {this.props.data.data.map((n, i) => {
              return (
                <ListItem
                  key={`${data.key}-${i}`}
                  dense
                  button
                  onClick={
                    this.props.data.read_only == true
                      ? this.doNothing()
                      : (event) => {
                          if (event.target.type !== 'checkbox') {
                            this.handleChange(n[0])(event);
                          }
                        }
                  }
                >
                  <Checkbox
                    classes={{
                      root: this.props.data.style || classes.checkbox,
                      checked: classes.checked,
                    }}
                    disabled={this.props.data.read_only}
                    checked={this.state.multiple_answer[n[0]] || false}
                    onChange={
                      this.props.data.read_only
                        ? this.doNothing
                        : this.handleChange(n[0])
                    }
                    value={n[0]}
                    onClick={(event) => event.stopPropagation()}
                  />

                  <div>
                    <div style={{ textAlign: 'left', display: 'inline' }}>
                      <ListItemText
                        className={classes.listtext}
                        disableTypography={true}
                        primary={
                          <p
                            style={{
                              marginBottom: 0,
                              fontWeight: 'normal',
                            }}
                            id={`${data.key}-${i}-answer-text`}
                          >
                            {n[1]}
                          </p>
                        }
                      />
                    </div>
                  </div>
                </ListItem>
              );
            })}
          </List>
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

const mapDispatchToProps = {
  dispatchaddPageData: (key, answer, question_text) =>
    addPageData({ key, answer, question_text }),
};

Multiplechoice.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Multiplechoice));
